import React, { memo, useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import Benchmarks from "../../Benchmarks";
import { Button, Icon, Stack } from "investira.react.components";
import { PageTemplate } from "../../../components/templates";
import { OUTPUT } from "../../../enums";
import EnquadramentoRegras from "../_components/EnquadramentoRegras";
import EnquadramentoRegrasAddDialog from "../_components/EnquadramentoRegrasAddDialog";
import EnquadramentoRegrasCopyDialog from "../_components/EnquadramentoRegrasCopyDialog";
import withRegras from "../../../hoc/withRegras";
import useKickBack from "../../../hooks/useKickBack";
import withMessage from "../../../hoc/withMessage";

const ReportSettingsBenchmarks = memo((props) => {
  const params = useParams();
  const location = useLocation();

  const [open, setOpen] = useState(false);

  function handleClose() {
    setOpen(false);
  }

  const kick = useKickBack();

  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);

  return <Benchmarks />;
});

export default withRegras(withMessage(ReportSettingsBenchmarks));
